import React from 'react';
import {
	Autocomplete,
	TextField,
	Box,
	AutocompleteRenderInputParams,
} from '@mui/material';

interface CustomAutocompleteWithAddNewProps {
	options: string[];
	value: string | null;
	onChange: (value: string, reason?: string) => void;
	placeholder?: string;
	width?: number | string;
	pointerEvents?:string;
	className?: string;
	onAddNewOption?: () => void;
}

const CustomAutocompleteWithAddNew: React.FC<
	CustomAutocompleteWithAddNewProps
> = ({
	options,
	onAddNewOption,
	value,
	onChange,
	placeholder = 'Type/Select',
	width,
	className,
	pointerEvents
}) => {
	const extendedOptions = [...options, '__add_new__'];

	return (
		<Autocomplete
			className={className}
			disableClearable
			value={value === '__add_new__' ? null : value}
			sx={{ width }}
			options={extendedOptions}
			onChange={(event, newValue, reason) => {
				if (newValue === '__add_new__') {
					onAddNewOption?.();
					onChange('', 'add-option');
				} else if (typeof newValue === 'string') {
					onChange(newValue, reason);
				}
			}}
			renderOption={(props, option) => {
				if (option === '__add_new__') {
					return (
						<Box
							component='li'
							{...props}
							sx={{
								justifyContent: 'center',
								color: '#9149ff',
								fontWeight: 500,
								pointerEvents:pointerEvents
							}}
						>
							+ Add New
						</Box>
					);
				}
				return (
					<Box component='li' {...props}>
						{option}
					</Box>
				);
			}}
			renderInput={(params: AutocompleteRenderInputParams) => (
				<TextField {...params} placeholder={placeholder} sx={{ width }} />
			)}
		/>
	);
};

export default CustomAutocompleteWithAddNew;
